import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { ConstantService } from "@services/constant"
import { Constants } from "@models/constants"
import { Term } from "@models/term";
import { Observable } from "rxjs/Observable"
import {
  FETCH_CONSTANTS,
  FETCH_CONSTANTS_FAILURE,
  POPULATE_CONSTANTS,
  FETCH_UPCOMING_TERM,
  POPULATE_UPCOMING_TERM,
  FETCH_UPCOMING_TERM_FAILURE
} from "@reducers/constants"

@Injectable()
export class ConstantsEffects {

  constructor(
    private actions: Actions,
    private constantsService: ConstantService
  ) {}

  @Effect() fetch = this.actions
    .ofType(FETCH_CONSTANTS)
    .switchMap((action: Action) => this.constantsService.all()
      .map((constants: Constants) => ({ type: POPULATE_CONSTANTS, payload: constants }))
      .catch(() => Observable.of({ type: FETCH_CONSTANTS_FAILURE }))
    )
    .share()

  @Effect() fetchUpcomingTerm = this.actions
    .ofType(FETCH_UPCOMING_TERM)
    .switchMap((action: Action) => this.constantsService.upcomingTerm()
      .map((term: Term) => ({ type: POPULATE_UPCOMING_TERM, payload: term }))
      .catch(() => Observable.of({ type: FETCH_UPCOMING_TERM_FAILURE }))
    )
    .share()

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/constants.ts